import { render, staticRenderFns } from "./billing.vue?vue&type=template&id=1995c39f&scoped=true&"
import script from "./billing.vue?vue&type=script&lang=js&"
export * from "./billing.vue?vue&type=script&lang=js&"
import style0 from "./billing.vue?vue&type=style&index=0&id=1995c39f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1995c39f",
  null
  
)

export default component.exports